var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-date-picker", {
    staticStyle: {
      height: "42px"
    },
    attrs: {
      value: _vm.value,
      clearable: _vm.clearable,
      type: "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": ["00:00:00", "23:59:59"],
      "picker-options": _vm.pickerOptions,
      editable: false,
      "unlink-panels": true
    },
    on: {
      input: _vm.handleInput
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };